<template>
  <page>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
              <message :messages="messages"></message>
              <form>
                <v-flex xs12>
                  <v-expansion-panels v-model="panel" multiple>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        <div>
                          <v-icon>mdi-filter-variant</v-icon> Date Range
                        </div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-card>
                          <v-card-text>
                            <v-container fluid grid-list-sm>
                              <v-layout row wrap>
                                <v-flex xs12 md6>
                                  <cal-picker v-model="reportForm.uwTranDateFrom" :label="labels.uwTranDateFrom" v-validate="'required'" :data-vv-as="labels.uwTranDateFrom" data-vv-name="uwTranDateFrom" :error-messages="errors.collect('uwTranDateFrom')"></cal-picker>
                                </v-flex>
                                <v-flex xs12 md6>
                                  <cal-picker v-model="reportForm.uwTranDateTo" :label="labels.uwTranDateTo" v-validate="toDateValidation(reportForm.uwTranDateFrom)" :data-vv-as="labels.uwTranDateTo" data-vv-name="uwTranDateTo" :error-messages="errors.collect('uwTranDateTo')" :min="this.reportForm.uwTransDateFrom"></cal-picker>
                                </v-flex>
                                <v-flex xs12 md6>
                                  <cal-picker v-model="reportForm.clmTranDateFrom" :label="labels.clmTranDateFrom" v-validate="'required'" :data-vv-as="labels.clmTranDateFrom" data-vv-name="clmTranDateFrom" :error-messages="errors.collect('clmTranDateFrom')"></cal-picker>
                                </v-flex>
                                <v-flex xs12 md6>
                                  <cal-picker v-model="reportForm.clmTranDateTo" :label="labels.clmTranDateTo" v-validate="toDateValidation(reportForm.clmTranDateFrom)" :data-vv-as="labels.clmTranDateTo" data-vv-name="clmTranDateTo" :error-messages="errors.collect('clmTranDateTo')" :min="this.reportForm.clmTransDateFrom"></cal-picker>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </v-card-text>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-flex>
                <v-flex xs12>
                  <v-expansion-panels v-model="panel" multiple>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        <div>
                          <v-icon>mdi-filter-variant</v-icon> Selection Criteria
                        </div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-card>
                          <v-card-text>
                            <v-container fluid grid-list-sm>
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <v-text-field v-model="reportForm.branch" :label="labels.branch" :error-messages="errors.collect('branch')" data-vv-name="branch" :data-vv-as="labels.branch" append-icon="mdi-magnify" @click:append="getHelpList('branch')" v-validate="'required'" readonly></v-text-field>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </v-card-text>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-flex>
              </form>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <v-checkbox v-model="reportForm.printRptRunTime" :label="labels.printRptRunTime" data-vv-name="printRptRunTime" :data-vv-as="labels.printRptRunTime"></v-checkbox>
          <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
            <v-icon left dark>mdi-file-export</v-icon>
            {{labels.export}}
          </v-btn>
          <v-btn-toggle dense mandatory v-model="reportForm.format">
            <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                <span>{{format.label}}</span>
                <v-icon :color="format.color">{{format.icon}}</v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-flex>
        </v-layout>
        <v-dialog v-model="brnFilter" width="900px" persistent>
          <branch-filter :menu="menu" @close="doClose" @doAssign="doAssign($event)"></branch-filter>
        </v-dialog>
    </v-container>
  </page>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import BranchFilter from './BranchFilter.vue'

export default {
  data() {
    return {
      labels: {
        uwTranDateFrom: 'Underwriting Transaction Date Form*',
        uwTranDateTo: 'Underwriting Transaction Date To*',
        clmTranDateFrom: 'Claims Transaction Date From*',
        clmTranDateTo: 'Claims Transaction Date To*',
        branch: 'Branch',
        format: 'Export Format',
        export: 'Export to',
        sendEmail: 'Send Output to Email?',
        printRptRunTime: 'Print Runtime Parameters'
      },
      reportForm: {
        uwTranDateFrom: new Date(),
        uwTranDateTo: new Date(),
        clmTranDateFrom: new Date(),
        clmTranDateTo: new Date(),
        branch: 'All',
        format: 'PDF',
        sendEmail: false,
        printRptRunTime: true
      },
      menu: {},
      supportedFormat: [],
      filterList: false,
      brnFilter: false,
      submitting: false,
      rptHistory: false,
      panel: [0]
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.uwReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  watch: {
    'supportedList': function (value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.reportForm.format = value[0].value
      }
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.uwReports.init !== 1) {
          await this.$store.dispatch('uwReportsInit')
        }
        const apiURI = this.rptMenu.initConsPrem
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    viewRptHistory() {
      this.rptHistory = true
    },
    doCloseHistory(rptKeys) {
      if (rptKeys !== undefined && rptKeys !== null) {
        JSON.parse(rptKeys, (key, value) => {
          switch (key) {
            case 'uwTranDateFrom': {
              this.reportForm.uwTranDateFrom = new Date(value)
              break
            }
            case 'uwTranDateTo': {
              this.reportForm.uwTranDateTo = new Date(value)
              break
            }
            case 'clmTranDateFrom': {
              this.reportForm.clmTranDateFrom = new Date(value)
              break
            }
            case 'clmTranDateTo': {
              this.reportForm.clmTranDateTo = new Date(value)
              break
            }
            case 'branch': {
              this.reportForm.branch = value
              break
            }
            case 'format': {
              this.reportForm.format = value
              break
            }
            case 'printRptRunTime': {
              this.reportForm.printRptRunTime = value
              break
            }
          }
        })
      }
      this.rptHistory = false
    },
    toDateValidation(fromDate) {
      const result = 'required|from_to_date:' + fromDate
      return result
    },
    getHelpList(fieldName) {
      this.brnFilter = true
    },
    doClose() {
      this.brnFilter = false
    },
    doAssign(data) {
      if (this.brnFilter) {
        this.reportForm.branch = []
        this.reportForm.branch = data.finalSelectedItems.toString()
      }
      this.brnFilter = false
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.post(apiURI, this.reportForm)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  created() {
    this.doInit()
  },
  mixins: [
    MessageMixin
  ],
  components: {
    BranchFilter
  }
}
</script>
